import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

export interface OfferRatingSubmit {
  rating: number;
  comments: string;
  contacted: boolean;
}

@Component({
  selector: 'app-offer-rating-molecule',
  imports: [],
  template: `
    <p class="rating__title">Cuéntanos tu experiencia</p>
    <p>Tu opinión es importante para nosotros y nos ayuda a mejorar.</p>
    <div class="rating__icons">
      <button type="button" [class.sel]="rating() === 1" (click)="rating.set(1)">
        <img src="assets/icons/mala_experiencia.svg" alt="Mala experiencia" />
      </button>
      <button type="button" [class.sel]="rating() === 2" (click)="rating.set(2)">
        <img src="assets/icons/neutral_experiencia.svg" alt="Neutral" />
      </button>
      <button type="button" [class.sel]="rating() === 3" (click)="rating.set(3)">
        <img src="assets/icons/buena_experiencia.svg" alt="Buena experiencia" />
      </button>
    </div>
    <div class="rating__info">
      <textarea
        placeholder="Cuéntanos tu experiencia..."
        maxlength="180"
        [value]="comments()"
        (input)="onCommentsChange($event)">
      </textarea>
      <div class="rating__switch-row">
        <p>¿Fuiste contactado por la entidad?</p>
        <div class="rating__toggle">
          <p>NO</p>
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              [id]="switchId()"
              [checked]="contacted()"
              (change)="onContactedChange($event)" />
            <label class="custom-control-label" [for]="switchId()"></label>
          </div>
          <p>SI</p>
        </div>
      </div>
    </div>
    <div class="rating__actions">
      <button type="button" [disabled]="rating() === 0 || comments() === ''" (click)="handleSubmit()">Enviar</button>
      <button type="button" class="rating__cancel" (click)="cancel.emit()">Cancelar</button>
    </div>
  `,
  styleUrl: './offer-rating-molecule.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferRatingMoleculeComponent {
  readonly switchId = input.required<string>();

  readonly ratingSubmit = output<OfferRatingSubmit>();
  readonly cancel       = output<void>();

  readonly rating    = signal(0);
  readonly comments  = signal('');
  readonly contacted = signal(false);

  onCommentsChange(event: Event): void {
    this.comments.set((event.target as HTMLTextAreaElement).value);
  }

  onContactedChange(event: Event): void {
    this.contacted.set((event.target as HTMLInputElement).checked);
  }

  handleSubmit(): void {
    if (this.rating() === 0 || this.comments() === '') return;
    this.ratingSubmit.emit({
      rating:    this.rating(),
      comments:  this.comments(),
      contacted: this.contacted(),
    });
  }
}
